import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import Menu from "@/model/menu";

@Module({ namespaced: true })
export default class MenuModule extends VuexModule {
  public menu: Menu = null;
  public menuList: Menu[] = [];

  @Mutation
  set(menu: Menu): void {
    this.menu = menu;
  }

  @Mutation
  setMenuList(menu: Menu[]): void {
    this.menuList = menu;
  }

  @Mutation
  addMenuList(menu: Menu): void {
    this.menuList.push(menu);
  }

  @Mutation
  getAMenu(identifier: any): Menu {
    let response = new Menu()
    this.menuList.map(value => {
      if (value.identifier === identifier) {
        response = value
      }
    })

    return response
  }

  @Mutation
  editMenuList(menu: Menu): void {
    this.menuList.map((value, key) => {
      if (value.identifier === menu.identifier) {
        this.menuList.splice(key, 1, menu)
      }
    });
  }

  @Mutation
  remove(index: number): void {
    this.menuList.splice(index, 1);
  }

  @Action({ rawError: true })
  setMenu(menu: Menu) {
    this.context.commit("set", menu);
  }

  @Action({ rawError: true })
  addMenuToList(menu: Menu) {
    this.context.commit("addMenuList", menu);
  }

  @Action({ rawError: true })
  editMenuToList(menu: Menu) {
    this.context.commit("editMenuList", menu);
  }

  @Action({ rawError: true })
  removeMenuInList(index: number) {
    this.context.commit("remove", index);
  }

  @Action({ rawError: true })
  clear() {
    this.context.commit("set", null);
  }

  @Action({ rawError: true })
  clearList() {
    this.context.commit("setMenuList", []);
  }

  get getMenu(): Menu {
    return this.menu;
  }

  get getMenuList(): Menu[] {
    return this.menuList;
  }

  @Action({ rawError: true })
  getAllMenu() {
    return this.getMenuList
  }

  @Action({ rawError: true })
  getMenuOnList(identifier: any) {
    let response = new Menu()
    this.menuList.map(value => {
      if (value.identifier === identifier) {
        response = value
      }
    })

    return response
  }

  @Mutation
  setQuantity(value: any): void {
    this.menuList.map(item => {
      if (item.identifier === value.identifier) {
        item.quantity = value.quantity
      }
    })
  }

  @Action({ rawError: true })
  setQuantityToMenuItem(value: any) {
    this.context.commit("setQuantity", value);
  }
}
